import { Button, toast } from '@osteopro/ui';
import { EyeOff } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../common/ConfirmDialog.js';
import { useSetChecklistHidden } from '../../hooks/api/use-onboarding.js';
import { errorMessage } from '../../lib/error-messages.js';

/**
 * « Ne plus afficher » : la confirmation du produit, puis le masquage déjà stocké
 * (`checklistHidden`). Le panneau et la page de mise en route passent par ici.
 */
export function OnboardingHideButton({ onHidden }: { onHidden?: () => void }) {
  const { t } = useTranslation();
  const hide = useSetChecklistHidden();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={hide.isPending}
        onClick={() => {
          setOpen(true);
        }}
        data-testid="button-onboarding-hide"
      >
        <EyeOff className="h-4 w-4" aria-hidden />
        {t('onboarding:required_gate.hide')}
      </Button>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={t('onboarding:required_gate.hide_confirm_title')}
        description={t('onboarding:required_gate.hide_confirm_description')}
        confirmLabel={t('common:answers.yes')}
        onConfirm={() => {
          hide.mutate(true, {
            onSuccess: () => {
              setOpen(false);
              onHidden?.();
            },
            onError: (error) => {
              toast({ title: errorMessage(error, t), variant: 'destructive' });
            },
          });
        }}
        testId="dialog-onboarding-hide"
      />
    </>
  );
}
